import Badge from '../Badge/Badge'
import Header from '../Header/Header'
import InfoPopOut from '../InfoPopOut/InfoPopOut'
import classes from './Fieldset.module.scss'
import type { ReactNode } from 'react'

export interface CommonProps {
  children?: ReactNode
  hasBoundary?: boolean
  hasPadding?: boolean
  isDisabled?: boolean
  isGrid?: boolean
  badge?: string
  badgeDescription?: ReactNode
}

export interface LabelWithoutDescription {
  label?: string
  sectionLabel: never
  hasBorderTop?: never
  description: never
  isRequired?: boolean
  infoPopOutVariant: never
}

export interface LabelWithDescription {
  label: string
  sectionLabel?: never
  hasBorderTop?: never
  description?: ReactNode
  isRequired?: boolean
  infoPopOutVariant?: 'widerWidth' | ''
}

export interface SectionWithoutDescription {
  label: never
  sectionLabel?: string
  hasBorderTop?: boolean
  description: never
  isRequired?: never
  infoPopOutVariant: never
}

export interface SectionWithDescription {
  label?: never
  sectionLabel: string
  hasBorderTop?: boolean
  description?: ReactNode
  isRequired?: never
  infoPopOutVariant?: 'widerWidth' | ''
}

export interface WithoutEither {
  label?: never
  sectionLabel?: never
  hasBorderTop?: never
  description?: never
  isRequired?: never
  infoPopOutVariant?: never
}
type Props = CommonProps & (LabelWithoutDescription | LabelWithDescription | SectionWithoutDescription | SectionWithDescription | WithoutEither)

// eslint-disable-next-line complexity
const Fieldset = ({
  children,
  sectionLabel,
  hasBoundary = false,
  hasBorderTop = true,
  isDisabled = false,
  description,
  hasPadding = false,
  label,
  isGrid = false,
  isRequired = false,
  badge,
  badgeDescription,
  infoPopOutVariant = ''
}: Props) => {
  const flexClassName = isGrid
    ? classes.FieldsetGrid
    : classes.FieldsetFlex

  const paddingClassName = hasPadding
    ? classes.Fieldset + ' ' + classes.hasPadding
    : classes.Fieldset

  const hasBoundaryClassName = hasBoundary
    ? classes.hasBoundary
    : undefined

  const hasBorderTopClassName = hasBorderTop
    ? classes.hasBorderTop
    : classes.noBorderTop

  const hasSectionLabelClassName = sectionLabel
    ? hasBorderTopClassName
    : undefined

  const classnames = [
    paddingClassName,
    hasBoundaryClassName,
    hasSectionLabelClassName
  ].filter(classnames => classnames).join(' ')

  return (
    <fieldset
      className={classnames}
      disabled={isDisabled}
    >
      {
        (label || sectionLabel) &&
          <legend>
            {
              !!sectionLabel &&
                <Header rank={3}>
                  {sectionLabel}
                </Header>
            }
            {
              !!label &&
                label
            }
            <span>
              {
                isRequired
                  ? '*'
                  : ''
              }
            </span>
            {
              description &&
                <InfoPopOut variant={infoPopOutVariant}>
                  {description}
                </InfoPopOut>
            }
            {
              badge &&
                <div className={classes.badgeWrapper}>
                  <Badge label={badge}>
                    {badgeDescription}
                  </Badge>
                </div>
            }
          </legend>
      }
      <div className={flexClassName}>
        {children}
      </div>
    </fieldset>
  )
}

export default Fieldset
